
import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

import "./style.scss";

export const PopupModal = props => {

  const handleClose = () => props.showModal(false);

  return (
    <Modal
      show={props.show}
      onHide={handleClose}
    >
    <Modal.Header closeButton>
      <Modal.Title>
        <Row xs={2} md={2}>
          <Col xs={2} sm={2} md={2}><div className="circle"></div></Col>
          <Col xs={9} sm={9} md={9}>{props.labels.modal_title}</Col>
        </Row>
      </Modal.Title>
    </Modal.Header>
  
    <Modal.Body>
      {props.labels.modal_body}
    </Modal.Body>
  
    <Modal.Footer>
      <Row>
        <Col sm={12} md={6}>
          <Button aria-label={props.labels.modal_submit} className="submit" onClick={handleClose}>{props.labels.modal_submit}</Button>
        </Col>
        <Col sm={12} md={6}>
          <Button aria-label="סגור פופ אפ" className="close" onClick={handleClose}>{props.labels.modal_cancel}</Button>
        </Col>
      </Row>
    </Modal.Footer>
  </Modal>
  )
};
